import { h, render } from 'vue'
import { Icon } from '@rapoo/element'
import { getCurrentScale } from '@/composables/useZoomScale'
import { DragImageOptions } from '../types'

const DEFAULT_SIZE = 36

const toPx = (value: number) => `${value}px`

const createDragImageElement = (options: DragImageOptions, scale: number) => {
  const width = (options.width ?? DEFAULT_SIZE) * scale
  const height = (options.height ?? DEFAULT_SIZE) * scale

  const root = document.createElement('div')
  root.style.width = toPx(width)
  root.style.height = toPx(height)
  root.style.display = 'flex'
  root.style.alignItems = 'center'
  root.style.justifyContent = 'center'
  root.style.gap = toPx(4 * scale)
  root.style.borderRadius = toPx(6 * scale)
  root.style.background = '#1757FF'
  root.style.color = '#FFFFFF'
  root.style.userSelect = 'none'
  root.style.pointerEvents = 'none'
  root.style.position = 'fixed'
  root.style.top = '-1000px'
  root.style.left = '-1000px'

  // icon容器
  const iconMount = document.createElement('div')
  iconMount.style.position = 'relative'
  iconMount.style.width = toPx(24 * scale)
  iconMount.style.height = toPx(24 * scale)
  iconMount.style.display = 'flex'
  iconMount.style.alignItems = 'center'
  iconMount.style.justifyContent = 'center'

  // icon和iconText一起渲染，确保iconText能正确显示在icon上
  const icon = options.icon
  if (icon) {
    render(
      h(Icon, {
        icon,
        class: 'w-5 h-5 shrink-0',
        style: { width: toPx(20 * scale), height: toPx(20 * scale) },
      }),
      iconMount,
    )
    root.appendChild(iconMount)
  }

  if (icon) {
    const iconTextEl = document.createElement('span')
    iconTextEl.style.position = 'absolute'
    iconTextEl.style.bottom = toPx(2 * scale)
    iconTextEl.style.right = '0'
    iconTextEl.style.fontSize = toPx(12 * scale)
    iconTextEl.style.lineHeight = '1'
    iconTextEl.style.whiteSpace = 'nowrap'
    iconMount.appendChild(iconTextEl)
  }

  // 常规文本
  const text = options.text
  if (text) {
    const textEl = document.createElement('span')
    textEl.textContent = text.slice(0, 5)
    textEl.style.fontSize = toPx(13 * scale)
    textEl.style.lineHeight = '1'
    textEl.style.whiteSpace = 'nowrap'
    root.appendChild(textEl)
  }

  return {
    element: root,
    cleanup: () => {
      render(null, iconMount)
      if (root.parentNode) {
        root.parentNode.removeChild(root)
      }
    },
  }
}

export const useDragImage = () => {
  const setDragImage = (event: DragEvent, options: DragImageOptions = {}) => {
    const dataTransfer = event.dataTransfer
    if (!dataTransfer) return

    const scale = getCurrentScale()
    const { element, cleanup } = createDragImageElement(options, scale)

    document.body.appendChild(element)

    const offsetX =
      options.offsetX === undefined
        ? Math.round(element.offsetWidth - 6 * scale)
        : Math.round(options.offsetX * scale)
    const offsetY =
      options.offsetY === undefined
        ? Math.round(element.offsetHeight - 8 * scale)
        : Math.round(options.offsetY * scale)
    dataTransfer.setDragImage(element, offsetX, offsetY)

    setTimeout(cleanup, 0)
  }

  return {
    setDragImage,
  }
}
